import React from 'react';
import { PendingSiteRequest } from 'services/company';

export function PendingSitesView(props: PendingSitesViewProps) {
  return <>
    {
      props.pendingSites.length
        ? <table className="table manage-sites-table is-fullwidth">
          <thead>
            <tr>
              <th>Company</th>
              <th>Site Name</th>
              <th>State</th>
              <th>Type</th>
              <th>Users</th>
              <th>Requested on</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              props.pendingSites.map((site, idx) => <tr key={site.siteId}>
                <td
                  className={idx === 1 ? 'first-site-row' : ''}
                >
                  <a href={`/organization/company/${site.companyId}`}>
                    {site.companyName}
                  </a>
                </td>
                <td>{site.siteName}</td>
                <td>{site.state}</td>
                <td>{site.type}</td>
                <td className='admin-user-count' tabIndex={0}>
                  <div className='dropdown is-hoverable'>
                    <div className='dropdown-trigger'>
                      <button className='button is-small is-clickable' disabled={site.siteUsers.length === 0} aria-haspopup='true' aria-controls='dropdown-menu4'>
                        <span>{site.siteUsers.length}</span>
                      </button>
                    </div>
                    {
                      site.siteUsers.length > 0
                        ? <div className='dropdown-menu' id='dropdown-menu4' role='menu'>
                          <div className='dropdown-content'>
                            {
                              site.siteUsers.map((user, idx) => <div key={idx} className='dropdown-item'>
                                <a href={`/organization/user/${user.userId}`}>{`${user.name} (${user.roles[0]})`}</a>
                              </div>)
                            }
                          </div>
                        </div>
                        : <></>
                    }
                  </div>
                </td>
                <td>{new Date(site.requestedOn).toDateString()}</td>
                <td>
                  <div className="buttons">
                    <button
                      className="button is-success is-small"
                      onClick={() => approveSiteRequest(site.siteId)}
                    >
                      <span className="icon">
                        <i className="fas fa-check"></i>
                      </span>
                    </button>
                    <button
                      className="button is-danger is-small"
                      onClick={() => rejectSiteRequest(site.siteId)}
                    >
                      <span className="icon">
                        <i className="fas fa-times"></i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
              )
            }
          </tbody>
        </table>
        : <div>
          No Pending Site Requests
        </div>
    }
  </>;
}

async function approveSiteRequest(siteId: number) {
  const response = await fetch('/organization/update_pending_site_request', {
    method: 'POST',
    body: JSON.stringify({
      siteId: siteId,
      shouldAccept: true
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (response.status === 200) {
    window.location.reload();
  }
}

async function rejectSiteRequest(siteId: number) {
  const response = await fetch('/organization/update_pending_site_request', {
    method: 'POST',
    body: JSON.stringify({
      siteId: siteId,
      shouldAccept: false
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (response.status === 200) {
    window.location.reload();
  }
}

type PendingSitesViewProps = {
  pendingSites: PendingSiteRequest[];
};